import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem} from 'reactstrap';
import { NavLink } from 'react-router-dom'


export default class Header extends Component {

   constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

    render() {
        return (
            <Navbar style={{backgroundColor: '#0097a7'}} inverse fixed='top' toggleable>
                <div className="container">
                    <NavbarToggler right onClick={this.toggle} />
                    <NavbarBrand href="#">PerroWeb</NavbarBrand>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink className='nav-link' to="/"
                                         activeClassName="selected">Inicio</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className='nav-link' to="/perros"
                                         activeClassName="selected">Perros</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className='nav-link' to="/blog" activeClassName="selected">Blog</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className='nav-link' to="/contacto" activeClassName="selected">Contacto</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </div>
        </Navbar>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js